import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);
const TOKEN_KEY = "garage_token";
const REMEMBER_KEY = "garage_remember";

// Token'ı localStorage (kalıcı) veya sessionStorage (oturum) içinde tutar.
// "Beni hatırla" işaretliyse localStorage kullanılır; değilse sessionStorage.
const preferredStorage = () => {
  const remember = localStorage.getItem(REMEMBER_KEY);
  if (remember === "0") return sessionStorage;
  return localStorage;
};

export const getToken = () =>
  localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);

export const setToken = (t, remember = true) => {
  // Her iki storage'dan da temizle
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  if (t) {
    if (remember) {
      localStorage.setItem(TOKEN_KEY, t);
      localStorage.setItem(REMEMBER_KEY, "1");
    } else {
      sessionStorage.setItem(TOKEN_KEY, t);
      localStorage.setItem(REMEMBER_KEY, "0");
    }
  }
};

// Attach token to every request
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Redirect on 401
api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      setToken(null);
      if (!window.location.pathname.startsWith("/print/")) {
        window.location.assign("/login");
      }
    }
    return Promise.reject(error);
  }
);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const t = getToken();
    if (!t) {
      setUser(null);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        setToken(null);
        setUser(null);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password, remember = true) => {
    const r = await api.post("/auth/login", { email, password });
    setToken(r.data.token, remember);
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = () => {
    setToken(null);
    setUser(null);
    window.location.assign("/login");
  };

  return <AuthCtx.Provider value={{ user, login, logout, setUser }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
